import { BROADCAST_SET_ATTENDEE_MUSIC_PROFILE } from 'actions/Types';

export const initialState = {};

export default (state = initialState, action) => {
  if (BROADCAST_SET_ATTENDEE_MUSIC_PROFILE === action.type) {
    const { attendeeId, contentShareAudioProfile } = action.payload;
    return { ...state, [attendeeId]: contentShareAudioProfile };
  }
  return state;
};
